import { PRODUCT_YOU_MIGHT_BE_INTO_LOCAL_STORAGE_KEY } from '@/modules/product/constants';
import { type YouMightBeIntoLocalStorageItem } from '@/modules/product/types';
import { getLocalStorageItem } from '@/modules/storage';
import { safeJsonParse } from '@/modules/storage/helpers';

export function getYouMightBeIntoListFromLocalStorage() {
  const youMightBeIntoJSON = getLocalStorageItem(
    PRODUCT_YOU_MIGHT_BE_INTO_LOCAL_STORAGE_KEY
  );

  const items = safeJsonParse(youMightBeIntoJSON, []);

  return items
    .map((item: string) => safeJsonParse(item))
    .filter(Boolean) as YouMightBeIntoLocalStorageItem[];
}
